import React from "react";
import Review from "./Review";

class ReviewList extends React.Component {
  getReviews() {
    this.props.getReviews();
  }

  render() {
    const { reviews, truncateText, truncateAt, merchant, showLocation } = this.props;

    if (reviews.length > 0) {
      return (
        <div id="reviews">
          {reviews.map((r) => (
            <Review {...r} key={r.id} showLocation={showLocation} truncateText={truncateText} truncateAt={truncateAt} />
          ))}
          {merchant.lastPage ? null : (
            <a className="bottom-btn load-more" onClick={this.getReviews.bind(this)}>
              Load more reviews
            </a>
          )}
        </div>
      );
    } else {
      return (
        <div id="reviews" style={{ marginBottom: "7em" }}>
          There are no reviews yet -- you can be the first!
        </div>
      );
    }
  }
}

export default ReviewList;



// WEBPACK FOOTER //
// ./src/shared/ReviewList.js